import React, { useState } from 'react';

import { useStyles } from '~/assets/styles';
import Menu from '~/components/core/Atomic/Menu';
import MenuItem from '~/components/core/Atomic/MenuItem';
import { PencilIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import type { IncidentConfigurationSummary } from '~/components/SystemConfiguration/IncidentConfigurationPage/types';

interface EditPolicyButtonProps {
  row: IncidentConfigurationSummary;
  onEdit: (row: IncidentConfigurationSummary) => void;
  trackMixpanelEvent: (incidentConfiguration: IncidentConfigurationSummary) => void;
  onEditClivePolicy: (row: IncidentConfigurationSummary) => void;
  isPolicyCliveConfigEnabled?: boolean;
  // Absent when the page passes no CategoriesScreen (ConfigurationPage gates it).
  onEditCategories?: (row: IncidentConfigurationSummary) => void;
}

const EditPolicyButton: React.FC<EditPolicyButtonProps> = ({
  row,
  onEdit,
  trackMixpanelEvent,
  onEditClivePolicy,
  isPolicyCliveConfigEnabled,
  onEditCategories,
}) => {
  const { classes } = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // Any entry beyond the plain edit needs the menu; with none, the pencil edits directly.
  const hasMenu = isPolicyCliveConfigEnabled || !!onEditCategories;

  const handleEditIconClick = (event: React.MouseEvent<HTMLElement>) => {
    if (hasMenu) {
      setAnchorEl(event.currentTarget as HTMLElement);
    } else {
      onEdit(row);
      trackMixpanelEvent(row);
    }
  };

  return (
    <div>
      <InlineIconButton
        icon={PencilIcon}
        tooltipTitle="Edit"
        className={`${classes.textIcon} ${classes.marginedIcon} ${classes.hoverableNonFilledIcon}`}
        onClick={(e: React.MouseEvent<HTMLElement>) => handleEditIconClick(e)}
      />
      {hasMenu && (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            onClick={() => {
              onEdit(row);
              trackMixpanelEvent(row);
              setAnchorEl(null);
            }}
          >
            Edit Policy Form
          </MenuItem>
          {isPolicyCliveConfigEnabled && (
            <MenuItem
              className="flex flex-row gap-4"
              onClick={() => {
                onEditClivePolicy(row);
                setAnchorEl(null);
              }}
            >
              Edit Clive Policy
            </MenuItem>
          )}
          {onEditCategories && (
            <MenuItem
              className="flex flex-row gap-4"
              onClick={() => {
                onEditCategories(row);
                setAnchorEl(null);
              }}
            >
              Edit Categories
            </MenuItem>
          )}
        </Menu>
      )}
    </div>
  );
};

export default EditPolicyButton;
